import React, { useContext } from 'react';
import { StyledPre } from 'flow/editor/styles';
import RHSTextField from './RHSTextField';
import { useAppDispatch } from '~/store/reduxHooks';
import { updateThreshold } from 'flow/store/redux/thunks/thresholdUpdates';
import { ThresholdContext } from '../context';

interface RHSRangeInputProps {
  shouldUseDefaultString: boolean;
  values: string[];
}

const RHSRangeInput = ({
  shouldUseDefaultString,
  values,
}: RHSRangeInputProps) => {
  const dispatch = useAppDispatch();
  const { populatedThreshold } = useContext(ThresholdContext);

  const updateRangeValue = (index: 0 | 1, newValue: string) => {
    const nextValues = [...values];
    nextValues[index] = newValue;
    dispatch(updateThreshold.rightValue(populatedThreshold.publicId, nextValues.join(',')));
  };

  return (
    <>
      <RHSTextField
        onChange={val => updateRangeValue(0, val)}
        shouldUseDefaultString={shouldUseDefaultString}
        value={values[0]}
      />
      <StyledPre>to</StyledPre>
      <RHSTextField
        onChange={val => updateRangeValue(1, val)}
        shouldUseDefaultString={shouldUseDefaultString}
        value={values[1] ?? ''}
      />
    </>
  );
};

export default RHSRangeInput;
